import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";

@Injectable()
export class DeliveryEndToEndSlaService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) { }

  getEndToEndSLA(url, params): Observable<any> {
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processEndToEndSLA.bind(this))
    );
  }

  processEndToEndSLA(data: any) {
    if (data && Object.keys(data.data).length 
    && !data.data.data.non_breached_quantity 
    && !data.data.data.in_process_quantity 
    && !data.data.data.breached_quantity) 
    return null;
    const underProcess = [],
      sla = [],
      qunatity = [],
      delivered_quantity = [],
      underProcess_quantity = []

    const processedData = this.drillDownData(data.data);
    
    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const chart1 = {
      delivered_quantity: (Number(allData["breached_quantity"])) + (Number(allData["non_breached_quantity"])),
      underProcess_quantity: (Number(allData["in_process_quantity"])),
      sla: Number(
        (
          (100 * allData["non_breached_quantity"]) /
          (allData["breached_quantity"] +
            allData["non_breached_quantity"])
        ).toFixed(2)
      ),
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        underProcess.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
              total
            ).toFixed(2)
          )
        );
        sla.push(
          Number(
            (
              (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
              total
            ).toFixed(2)
          )
        );

        delivered_quantity.push(total);
        underProcess_quantity.push(__v2Data[_dataName]["data"]["in_process_quantity"])
      });
    }
    const chart2 = { underProcess, sla, delivered_quantity, underProcess_quantity, dataKeys };
    return { chart1, chart2 };
  }

  createChart(chartData, Options) {
    const chart1 = JSON.parse(JSON.stringify(HSET.chart1));
    const chart2 = JSON.parse(JSON.stringify(HSET.chart2));
    //chart1.series[0].data = [chartData.chart1.underProcess];
    chart1.series[0].data = [chartData.chart1.sla];
    chart1.series[1].data = [chartData.chart1.underProcess_quantity];
    chart1.series[2].data = [chartData.chart1.delivered_quantity];
    chart1.xAxis.categories = [chartData.chart1.allKey];

    //chart2.series[0].data = chartData.chart2.underProcess;
    chart2.series[0].data = chartData.chart2.sla;
    chart2.series[1].data = chartData.chart2.underProcess_quantity;
    chart2.series[2].data = chartData.chart2.delivered_quantity;
    chart2.xAxis.categories = chartData.chart2["dataKeys"];
    chart1.tooltip.positioner = function () {
      return { x: 10, y: 60 };
    };
    return { chart1, chart2 };
  }

  drillDownData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }
}
